import React, { useState, useEffect } from "react";
import { useRecoilValue } from 'recoil';
import { geoBoundaryListRefreshState, IGeoBound } from '../../../../../core/store/GeoBoundaryStore';
import { isMobile, isTablet } from "react-device-detect";
import Button from '@material-ui/core/Button';
import { useSpinner } from "../../../../../core/contexts/SpinnerContext";
import { useNotification } from "../../../../../core/contexts/NotificationContext";
import * as GeoBoundaryApi from '../../../../Common/Apis/GeoBoundaryApi';
import { geoBoundaryDataOrder, dataOrderAs } from "../../../../../includes/variables";
import GeoBoundaryListItem from './GeoBoundaryListItem/GeoBoundaryListItem';

interface IProps {
  addTab: any;
}

const GeoBoundaryList = ({ addTab }: IProps) => {

  const { setSpinner } = useSpinner();
  const { showSuccess } = useNotification();


  const [listData, setListData] = useState();
  const [pageSize, setpageSize] = useState((isMobile && !isTablet) ? 10 : 100);
  const [pageNo, setpageNo] = useState(1);
  const [sortField, setSortField] = useState(geoBoundaryDataOrder.GeoBoundaryId);
  const [sortOrder, setSortOrder] = useState(1);
  const listRefresh = useRecoilValue(geoBoundaryListRefreshState);

  useEffect(() => {
    getList(1, pageSize, sortField, sortOrder);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [listRefresh]);

  const refreshPage = () => {

    getList(pageNo, pageSize, sortField, sortOrder);
  };

  const pageSizeChanged = (i: number) => {
    setpageSize(i);
    setpageNo(1);
    getList(1, i, sortField, sortOrder);
  };

  const pageNoChanged = (i: number) => {
    setpageNo(i);
    getList(i, pageSize, sortField, sortOrder);
  };

  const sortFieldChanged = (e: any) => {
    setSortField(e.sortField);
    setSortOrder(e.sortOrder);
    getList(pageNo, pageSize, e.sortField, e.sortOrder);
  };

  const submitForm = (e: any) => {
    e.preventDefault();
    getList(pageNo, pageSize, sortField, sortOrder);
  };

  const deleteGeoBound = async (item: IGeoBound) => {

    if (!window.confirm("Do you want to delete this geo bound?")) {
      return;
    }

    try {
      setSpinner(true);

      await GeoBoundaryApi.deleteGeoBoundary(item.GeoBoundaryId);


      showSuccess("success", "sucessfully deleted", "", 3000, null);
      setSpinner(false);
      refreshPage();

    }
    catch (err) {
      console.log('err', err);
    }
    setSpinner(false);

  };

  const getList = async (_pageNo: number, _pageSize: number, _sortField: string, _sortOrder: number) => {

    setSpinner(true);

    try {

      const resData = await GeoBoundaryApi.getGeoBoundaryList(_sortField
        , _sortOrder === 1 ? dataOrderAs.ASC : dataOrderAs.DESC
        , _pageNo, _pageSize);

      setListData(resData);

    } catch (err) {
      console.log('err', err);
    }

    setSpinner(false);
  };

  return (
    <>
      <div className="row no-gutters">
        <div className="col-lg-12  mt-3">
          <div className="tab-content" id="myTabContent">
            <div className="card">
              <div className="card-body">
                <form onSubmit={submitForm}>
                  <div className="row ">

                    <div className="col-lg-2">
                      <div className="form-group">
                        <Button
                          type="submit"
                          //className=" ml-3"
                          style={{ fontWeight: '600' }}
                          variant="contained"
                          color="primary"
                        >
                          Refresh
                        </Button>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>

        <div className="col-md-12  mt-3">
          <div className="tab-content" id="myTabContent">
            {listData && <GeoBoundaryListItem
              items={listData}
              addTab={addTab}
              pageSizeChanged={pageSizeChanged}
              pageNoChanged={pageNoChanged}
              sortFieldChanged={sortFieldChanged}
              sortField={sortField}
              sortOrder={sortOrder}
              deleteGeoBound={(e: IGeoBound) => deleteGeoBound(e)}
            />}

          </div>
        </div>
      </div>
    </>
  );
};

export default GeoBoundaryList;
